import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';
import { OwaDate } from 'owa-datetime';

export default action(
    'SCHEDULE_ROWS',
    (
        rowKeys: string[],
        tableViewId: string,
        actionSource: ActionSource,
        scheduleReturnTime: OwaDate | undefined
    ) => ({
        rowKeys,
        tableViewId,
        actionSource,
        scheduleReturnTime,
    })
);
